<script lang="ts" setup>
import { mdiTriangleSmallUp } from '@mdi/js'
import { useHotkey } from 'vuetify'
import { useStateScope } from '../../helper/shortcut'

interface Props {
  keys: string
  always?: boolean
  hidden?: boolean
  action?: () => any
  disabled?: boolean
  floating?: boolean
  onlyDisplay?: boolean
  color?: string
  top?: string
  preventDefault?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  always: false,
  hidden: false,
  disabled: false,
  floating: false,
  onlyDisplay: false,
})

const showKeybinds = useLocalStorage('showKeybinds', true)

const scope = useStateScope()

const shouldShow = computed(() => {
  if (props.always)
    return true
  if (props.hidden)
    return false
  return showKeybinds.value
})

const fnRunning = ref(false)

async function callback() {
  if (fnRunning.value || props.disabled || props.onlyDisplay || !props.action)
    return
  fnRunning.value = true
  await Promise.resolve(props.action())
  fnRunning.value = false
}

let cleanup: () => void

watch(() => props.onlyDisplay, () => {
  if (props.onlyDisplay) {
    if (cleanup) {
      cleanup()
    }
    return
  }

  cleanup = useHotkey(props.keys, callback, { preventDefault: props.preventDefault })
}, { immediate: true })

scope?.watchShortcut(props.keys, callback)
</script>

<template>
  <div v-if="shouldShow" :class="floating ? 'shortcut-floating' : ''">
    <div v-if="floating" style="margin-top: -11px; opacity: 0.1;" :style="{ top: props.top ?? '90%' }">
      <v-icon :icon="mdiTriangleSmallUp" />
    </div>
    <v-chip density="compact" size="x-small" :style="{ top: props.top ?? '90%' }">
      <v-hotkey :keys="props.keys" variant="text" :style="disabled ? 'opacity: 0.3' : ''" display-mode="symbol" :color="color" />
    </v-chip>
  </div>
</template>

<style>
.shortcut-floating {
  display: contents;
}

.shortcut-floating > * {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  user-select: none;
  pointer-events: none;
  z-index: 900;
}
</style>
